import React from 'react';
import { motion } from 'framer-motion';
import './Footer.css';

const Footer = () => {

  return (
    <footer className="footer">
      <div className="container">
        <motion.div
          className="footer-content"
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        >
          <div className="footer-main">
            <div className="footer-logo">
              <img src="/assets/jmb-logo-branco-500.png" alt="JMB Designer" width={52} />
              <div className="logo-text">
                <span className="logo-name">João Marcos</span>
                <span className="logo-subtitle">Designer Gráfico</span>
              </div>
            </div>

            <div className="footer-links">
              <div className="links-column">
                <h4>Navegação</h4>
                <ul>
                  <li><a href="#home">Home</a></li>
                  <li><a href="#portfolio">Portfólio</a></li>
                  <li><a href="#about">Quem Sou</a></li>
                  <li><a href="#contact">Contatos</a></li>
                </ul>
              </div>

              <div className="links-column">
                <h4>Serviços</h4>
                <ul>
                  <li><a href="#portfolio">Logotipos</a></li>
                  <li><a href="#portfolio">Identidade Visual</a></li>
                  <li><a href="#portfolio">Branding</a></li>
                  <li><a href="#portfolio">Design Digital</a></li>
                </ul>
              </div>

              <div className="links-column">
                <h4>Contato</h4>
                <ul>
                  <li><a href="mailto:jmbdesigner@gmail.com">jmbdesigner@gmail.com</a></li>
                  <li><a href="tel:+5515981168798">+55 (15) 98116-8798</a></li>
                  <li><span>Sorocaba, SP</span></li>
                </ul>
              </div>
            </div>
          </div>

          <div className="footer-bottom">
            <div className="copyright">
              <p>
                © {new Date().getFullYear()} JMB Designer. Todos os direitos reservados.
              </p>
              <p className="made-with">
                Desenvolvido por <motion.a 
                href="https://www.joaopedrobatistadev.com.br/" 
                target="_blank" 
                rel="noopener noreferrer"
              >João Pedro Batista Dev</motion.a>.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;
